/**
 * @module hooks/useAuth
 * @category Hooks
 * @description Um hook que fornece acesso ao contexto de autenticação do usuário.
 * @returns {Object} O contexto de autenticação, que contém informações sobre o usuário.
 */
import { useContext } from 'react';
import AuthContext from '../contexts/JWTContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
